// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__IO7ln","fileBtn":"File_fileBtn__27v3A","closeBtn":"File_closeBtn__33G9_","fileSelected":"File_fileSelected__2vP8Z","disabled":"File_disabled__2eaMB"};